// extracted by css-extract-rspack-plugin
var _1 = "wGyvL";
var _2 = "QMOfe";
var _3 = "lvhUc";
export { _1 as "tagFill", _2 as "tagOutline", _3 as "tagWrapper" }
